import { iframeResizer } from "iframe-resizer";

export default defineNuxtPlugin( ( nuxtApp ) => {
  nuxtApp.vueApp.directive( "resize", {
    beforeMount ( el, { value = {} } ) {
      if ( import.meta.client ) {
        iframeResizer( value, el );
      }
    },
    unmounted ( el ) {
      if ( import.meta.client ) {
        el.iFrameResizer.removeListeners();
      }
    },
  } );
} );
